"use strict";

/**
* Adjusts the position of UGC map anchors within a modal when the modal is displayed.
* This function observes changes to the modal's style attribute to detect when it becomes visible.
* Once visible, it centers the anchors vertically within the tagging image container and manages
* a loading spinner during the adjustment process.
*/
function fixUgcMap() {
    var $modalElement = $("#ls-slider-popup-container");
    var modalShown = false;

    var modalObserver = new MutationObserver(function (mutationsList) {
        mutationsList.forEach(function (mutation) {
            if (mutation.type === "attributes" && mutation.attributeName === "style") {
                var displayStyle = $modalElement.css("display");
                if (displayStyle !== "none" && !modalShown) {
                    modalShown = true;

                    $modalElement.addClass("spinner-active");
                    $.spinner().start();

                    setTimeout(function () {
                        var $anchors = $modalElement.find(".js-click .anchor");
                        var imageContainerHeight = $modalElement.find(".js-tagging-image").height();
                        var heightImage = $modalElement.find(".js-tagging-content").height();
                        var heightDifference = (imageContainerHeight - heightImage) / 2;

                        $anchors.each(function () {
                            var currentTopPosition = parseFloat($(this).css("top").replace("px", ""));
                            var newTopPosition = currentTopPosition - heightDifference + "px";

                            $(this).css("top", newTopPosition);
                        });

                        $modalElement.removeClass("spinner-active");
                        $.spinner().stop();
                        modalObserver.disconnect();
                    }, 3500);
                }
            }
        });
    });

    var config = { attributes: true, attributeFilter: ["style"] };

    modalObserver.observe($modalElement[0], config);
}

module.exports = function () {
    $(document).ready(function () {
        var observer = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
                if (mutation.addedNodes.length > 0) {
                    checkForElement();
                }
            });
        });

        function checkForElement() {
            var $ugcCarouselContainer = $(".ls-slider-widget-container");

            if ($ugcCarouselContainer.length > 0) {
                var $ugcCarouselHeader = $(".js-ugc-carousel-header");
                var $ugcEmptyCarouselHeader = $(".js-ugc-empty-carousel-header");
                var $ugcEmptyCarouselContent = $(".js-ugc-empty-carousel-content");

                // Introduce a delay before checking for the .empty class
                setTimeout(function () {
                    if ($ugcCarouselContainer.find(".empty").length > 0) {
                        $ugcEmptyCarouselContent.removeClass("d-none");
                        $ugcEmptyCarouselHeader.removeClass("d-none");
                        $ugcCarouselHeader.addClass("d-none");
                        $ugcCarouselContainer.addClass("d-none");
                    } else {
                        $ugcEmptyCarouselHeader.addClass("d-none");
                        $ugcCarouselHeader.removeClass("d-none");

                        $(".ls-slider-container").off("click").on("click", ".js-click-image", function () {
                            if ($(this).closest(".js-pdp-recs").length > 0) {
                                window.dispatchEvent(new CustomEvent("pdpUgcClick"));
                            }

                            if (window.innerWidth >= 850) {
                                fixUgcMap();
                            }
                        });
                    }

                    observer.disconnect();
                }, 1000);
            }
        }

        var config = { childList: true, subtree: true };

        observer.observe(document.body, config);
    });
};
